import { useFormContext, Controller } from 'react-hook-form';
import React, { useState, forwardRef, useImperativeHandle } from 'react';
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography
} from '@mui/material';
import { RHFTextField } from '../../../fl-components/hook-form';
import Iconify from '../../../fl-components/Iconify';
import CheckFillIcon from '../../../svg/CheckFillIcon';
import palette from '../../../theme/palette';

// eslint-disable-next-line
const MCQFeed = forwardRef(({ }, ref) => {
  // Add option state
  const [addOption, setAddOption] = useState(0);
  // Form control
  const { control, getValues, setValue } = useFormContext();
  // Answer index
  const [selectedAnswerIndex, setSelectedAnswerIndex] = useState(null);
  // Answer error
  const [isError, setIsError] = useState(false);

  useImperativeHandle(ref, () => ({
    validateAnswer() {
      return validateMCQAnswer();
    }
  }));

  const validateMCQAnswer = () => {
    if (selectedAnswerIndex === null) {
      setIsError(true);
    } else {
      setIsError(false);
    }
    return selectedAnswerIndex;
  };

  return (
    <Box>
      <RHFTextField name="question" label="Your question" margin="dense" sx={{ mb: 3 }} />

      <Stack direction="row" spacing={2} alignItems="center">
        <RHFTextField name="option1" label="Option 1" margin="dense" />
        <IconButton style={{ marginLeft: 5 }} onClick={() => setSelectedAnswerIndex(0)}>
          <CheckFillIcon
            color={selectedAnswerIndex === 0 ? palette.secondary.main : palette.grey[400]}
          />
        </IconButton>
      </Stack>

      <Stack direction="row" spacing={2} alignItems="center">
        <RHFTextField name="option2" label="Option 2" margin="dense" />
        <IconButton style={{ marginLeft: 5 }} onClick={() => setSelectedAnswerIndex(1)}>
          <CheckFillIcon
            color={selectedAnswerIndex === 1 ? palette.secondary.main : palette.grey[400]}
          />
        </IconButton>
      </Stack>

      {addOption >= 1 && (
        <Stack direction="row" spacing={2} alignItems="center">
          <Controller
            name="option3"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <FormControl fullWidth margin="dense" variant="outlined">
                <InputLabel htmlFor="outlined-option-3">Option 3</InputLabel>
                <OutlinedInput
                  id="outlined-option-3"
                  {...field}
                  error={!!error}
                  helperText={error?.message}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          if (getValues('option4')) {
                            field.onChange(getValues('option4'));
                            setValue('option4', '');
                          } else {
                            field.onChange(getValues(''));
                          }
                          setAddOption(addOption - 1);
                        }}
                        edge="end"
                      >
                        <Iconify icon="charm:cross" />
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Option 3"
                />
              </FormControl>
            )}
          />
          <IconButton style={{ marginLeft: 5 }} onClick={() => setSelectedAnswerIndex(2)}>
            <CheckFillIcon
              color={selectedAnswerIndex === 2 ? palette.secondary.main : palette.grey[400]}
            />
          </IconButton>
        </Stack>
      )}
      {addOption === 2 && (
        <Stack direction="row" spacing={2} alignItems="center">
          <Controller
            name="option4"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <FormControl fullWidth margin="dense" variant="outlined">
                <InputLabel htmlFor="outlined-option-4">Option 4</InputLabel>
                <OutlinedInput
                  id="outlined-option-4"
                  {...field}
                  error={!!error}
                  helperText={error?.message}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          field.onChange('');
                          setValue('option4', '');
                          setAddOption(addOption - 1);
                        }}
                        edge="end"
                      >
                        <Iconify icon="charm:cross" />
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Option 4"
                />
              </FormControl>
            )}
          />
          <IconButton style={{ marginLeft: 5 }} onClick={() => setSelectedAnswerIndex(3)}>
            <CheckFillIcon
              color={selectedAnswerIndex === 3 ? palette.secondary.main : palette.grey[400]}
            />
          </IconButton>
        </Stack>
      )}

      {isError && (
        <Typography color="red" mt={1}>
          Please select answer
        </Typography>
      )}

      {addOption !== 2 && (
        <Stack justifyContent="end" direction="row" mt={3}>
          <Button
            startIcon={<Iconify icon="akar-icons:plus" />}
            // variant="contained"
            onClick={() => setAddOption(addOption + 1)}
          >
            Add Option
          </Button>
        </Stack>
      )}
    </Box>
  );
});

export default MCQFeed;
